// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#app[data-v-713c3bb0]{-webkit-print-color-adjust:exact;display:flex;height:100%;overflow:hidden;background-color:#fff}#app.nativeIos[data-v-713c3bb0]{background-color:transparent}.pageWrapper[data-v-713c3bb0]{width:100%;height:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
